// extracted by mini-css-extract-plugin
export var backToHomeContainer = "HeaderConnector-module--backToHomeContainer--537e4";
export var cta = "HeaderConnector-module--cta--90886";
export var ctaContainer = "HeaderConnector-module--ctaContainer--d8fae";
export var headerContainer = "HeaderConnector-module--headerContainer--c4d81";
export var headerTopWrapper = "HeaderConnector-module--headerTopWrapper--1c6aa";
export var headerWrapper = "HeaderConnector-module--headerWrapper--84137";
export var logoDesktop = "HeaderConnector-module--logoDesktop--53e5f";
export var menuContainer = "HeaderConnector-module--menuContainer--cc755";
export var mobileLogoOverlap = "HeaderConnector-module--mobileLogoOverlap--02136";
export var notificationsContainer = "HeaderConnector-module--notificationsContainer--29682";